import { render, staticRenderFns } from "./opiniondetails.vue?vue&type=template&id=bbc65176&scoped=true&"
import script from "./opiniondetails.vue?vue&type=script&lang=js&"
export * from "./opiniondetails.vue?vue&type=script&lang=js&"
import style0 from "./opiniondetails.vue?vue&type=style&index=0&id=bbc65176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc65176",
  null
  
)

export default component.exports